import React from 'react'
import {connect} from "react-redux";
import FnButton from "./FnButton";
import {send_cmd, send_lc_cmd} from "../etc/cmd";

import LcDetail from "./lc_detail";


const FnBox = ({lc, gs, showcv, setshowcv}) => {

    function vChanged(val) {
        this.setState({v: val});
    }

    function dirChanged(val) {
        this.setState({dir: val});
    }

    function fnChanged(bit) {
        let mask = 0;
        if( bit < 5) {
            mask += 2;
        } else if( bit < 13) {
            mask += 4;
        } else if( bit < 21) {
            mask += 8;
        } else if( bit < 29) {
            mask += 10;
        }

        let cc = {
            id: lc.id,
            v: lc.v,
            dir: lc.dir,
            fn: (lc.fn ^ (1 << bit)),
            fnchanged: bit,
            mask: mask,
        }
        send_lc_cmd(cc);
    }

    let stylex = {
        display: 'inline-grid',
        gridTemplateColumns: 'auto auto auto auto auto auto auto',
        padding: '2px',
        gridGap: '5px',
        margin: '5px',
    };

    let styley = {
        display: 'inline-grid',
        gridTemplateColumns: 'auto auto',
        padding: '2px',
        gridGap: '5px',
        margin: '5px',
        marginBottom: '-5px',
        columns: 7,
    };

    const btns = []
    {
        for (let i = 1; i < 29; i += 1) {
            btns.push(<FnButton key={i} checked={lc.fn & (1 << i)} num={i} click={() => fnChanged(i)}/>)
        }
    }


    return (
        <>
            <div style={styley}>
                <FnButton key={0} checked={lc.fn & (1 << 0)} num={0} click={() => fnChanged(0)}/>
                <LcDetail lc={lc} showcv={showcv} setshowcv={setshowcv}/>
            </div>
            <div style={stylex}>
                {btns}
            </div>
        </>
    )

}

function mapStateToProps(state, other) {
    return state;
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FnBox)
